<template lang="pug">
.hightlight-tabs.position-relative
  .text-center
    nav.d-inline-flex.align-items-center.tabnav
      button.button.button-primary.button-tdays
        font-awesome-icon(icon="home")
      button.button.button-primary.button-tdays
        font-awesome-icon(icon="tag")
  .container.tabs
    slot
</template>

<script>
export default {
  name: "HomeHighlightTabs",
};
</script>

<style lang="scss" scoped>
.tabnav {
  .button {
    font-size: 1.5rem;
    padding: 0;
    text-align: center;
    width: 65px;
    aspect-ratio: 1;
    border-radius: 50%;
    position: relative;
    margin: 0 0.25rem;
    .label {
      position: absolute;
      font-size: 1rem;
    }
  }
}
</style>
